module.exports = __webpack_public_path__ + "img/dental-slide-01.3c37a5f1.jpeg";